module.exports = __webpack_public_path__ + "static/media/hostGator.9fedb5d0.svg";